(function () {

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7bbe"];
var parcelRegister = parcelRequire.register;
parcelRegister("oPeBr", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $efd1b582a650743b$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");

var $dTCkE = parcelRequire("dTCkE");

var $exvWl = parcelRequire("exvWl");

var $l8eky = parcelRequire("l8eky");
function $efd1b582a650743b$export$2e2bcd8739ae039({ label: label, name: name, required: required, minLength: minLength, maxLength: maxLength, min: min, max: max, pattern: pattern, validate: validate, placeholder: placeholder, type: type = "text", desktopWidth: desktopWidth, onChange: onChange, controller: controller, disabled: disabled, positionError: positionError, lettersOnly: lettersOnly, minimalisticDesign: minimalisticDesign, labelOnBg: labelOnBg }) {
    const { setValue: setFormContextValue, formState: formState, register: formContextRegister } = (0, $exvWl.useFormContext)();
    let error = formState.errors?.[name];
    const controllerValue = controller?.value;
    (0, $dTCkE.useEffect)(()=>{
        setFormContextValue(name, controllerValue, {
            shouldDirty: true
        });
    }, [
        controllerValue,
        setFormContextValue,
        name
    ]);
    const { onChange: formContextRegOnChange, ...formContextRegRest } = formContextRegister(name, {
        required: required,
        minLength: minLength,
        min: min,
        maxLength: maxLength,
        max: max,
        pattern: pattern,
        validate: validate
    });
    return /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
        className: `input-form-container self-start md:px-2 relative w-full rounded-md ${name === "SelectedCities" || name === "InterestedIn" ? "" : "my-5 md:my-3"} ${type}${desktopWidth === "full" ? " md:w-full" : " md:w-1/2"}`,
        children: [
            /*#__PURE__*/ (0, $a9eYm.jsx)("input", {
                type: type,
                readOnly: disabled,
                ...formContextRegRest,
                placeholder: placeholder,
                required: required,
                onChange: (e)=>{
                    error = undefined;
                    formContextRegOnChange(e);
                    onChange?.(e.target.value);
                    controller?.setValue?.(e.target.value);
                },
                className: `${minimalisticDesign ? "border-b-1 !p-2" : "border-1 rounded-md"} w-full inputText outline-none font-ic ${name === "SelectedCities" || name === "InterestedIn" ? "hidden" : ""} ${error ? "border-red500" : "focus-within:bg-white border-grey100 focus-within:border-grey300"}`,
                onKeyDown: (e)=>{
                    (0, $l8eky.restrictToOnlyLetters)(e, lettersOnly);
                }
            }),
            /*#__PURE__*/ (0, $a9eYm.jsxs)("p", {
                className: `m-0 absolute text-red500 text-tiny ${positionError === true ? "z-10 px-1 md:px-2 top-0 left-2 md:left-4 transform translate-y-1/2- bg-white" : ""}`,
                children: [
                    error?.type === "required" && "F\xe4ltet \xe4r obligatoriskt",
                    error?.type === "minLength" && "F\xf6r f\xe5 antal tecken",
                    error?.type === "maxLength" && "F\xf6r m\xe5nga antal tecken",
                    type === "tel" && error?.type === "pattern" && `Fyll i ett giltigt telefonnummer`,
                    name === "email" && error?.type === "pattern" && `Fyll i en giltig e-postadress`,
                    name === "zipCode" && error?.type === "pattern" && `Ange giltigt postnr`,
                    name === "city" && error?.type === "pattern" && `Ange giltig postort`,
                    (name === "firstname" || name === "lastname") && error?.type === "pattern" && `Kontrollera att namnet \xe4r korrekt`
                ]
            }),
            /*#__PURE__*/ (0, $a9eYm.jsx)("label", {
                className: `px-1  bg-white left-0 font-ic md:left-4 absolute text-left floating-label ${minimalisticDesign ? "minimalistic" : ""} ${name === "SelectedCities" || name === "InterestedIn" ? "hidden" : ""} ${error ? "text-red500" : "text-black700"} ${labelOnBg ? "label-on-bg" : ""}`,
                children: label
            })
        ]
    });
}

});

parcelRegister("1A7pc", function(module, exports) {
(function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    "use strict";
    /* eslint-disable no-var */ function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)target[key] = source[key];
        }
        return target;
    }
    /* eslint-enable no-var */ /* eslint-disable no-var */ var defaultConverter = {
        read: function(value) {
            if (value[0] === '"') value = value.slice(1, -1);
            return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function(value) {
            return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
    };
    /* eslint-enable no-var */ /* eslint-disable no-var */ function init(converter, defaultAttributes) {
        function set(name, value, attributes) {
            if (typeof document === "undefined") return;
            attributes = assign({}, defaultAttributes, attributes);
            if (typeof attributes.expires === "number") attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
            if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
            name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var stringifiedAttributes = "";
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += "; " + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
            }
            return document.cookie = name + "=" + converter.write(value, name) + stringifiedAttributes;
        }
        function get(name) {
            if (typeof document === "undefined" || arguments.length && !name) return;
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split("; ") : [];
            var jar = {};
            for(var i = 0; i < cookies.length; i++){
                var parts = cookies[i].split("=");
                var value = parts.slice(1).join("=");
                try {
                    var found = decodeURIComponent(parts[0]);
                    jar[found] = converter.read(value, found);
                    if (name === found) break;
                } catch (e) {}
            }
            return name ? jar[name] : jar;
        }
        return Object.create({
            set: set,
            get: get,
            remove: function(name, attributes) {
                set(name, "", assign({}, attributes, {
                    expires: -1
                }));
            },
            withAttributes: function(attributes) {
                return init(this.converter, assign({}, this.attributes, attributes));
            },
            withConverter: function(converter) {
                return init(assign({}, this.converter, converter), this.attributes);
            }
        }, {
            attributes: {
                value: Object.freeze(defaultAttributes)
            },
            converter: {
                value: Object.freeze(converter)
            }
        });
    }
    var api = init(defaultConverter, {
        path: "/"
    });
    /* eslint-enable no-var */ return api;
});

});

})();
//# sourceMappingURL=FormInput.07b8398d.js.map
